import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from '@COMPONENTS/HEADERS/Header';
import MainHeader from '@COMPONENTS/HEADERS/MainHeader';

function BasicLayout() {
    return (
        <>
            <Header>
                <MainHeader />
            </Header>

            <main>
                <Outlet />
            </main>
        </>
    );
}

export default BasicLayout;
